module.exports = __webpack_public_path__ + "img/VideoPoster.a6e160bc.png";